module.exports = __webpack_public_path__ + "img/null-box.bb73dd88.png";